<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onDelete="() => {}"
    :onUpdate="() => {}"
    :onStore="() => {}"
    :enableSearch="true"
    :formInputs="formInputs"
    :transform="transformCobranca"
    :transformUpdate="transformSalvar"
    :transformStore="transformSalvar"
    :check-alerts="true"
    primaryKey="id"
  >
    <template v-slot:icone="{ model }">
      <span v-if="model.icone" class="icone-column">
        <fa-icon :icon="resolveIcon(model.icone)" />
      </span>
      <span v-else class="icone-column-empty">-</span>
    </template>
  </crud-base>
</template>

<script>
import CrudBase from "../../../components/crud/CrudBase";
import {
  schemaBooleanSelect,
  schemaIconPicker,
  schemaMoney,
  schemaMultiSelect,
  schemaNumber,
  schemaReadOnly,
  schemaPercent, schemaSelect,
  schemaTextArea,
  schemaTextField
} from "@/helpers/form";
import {yesNoRepresentation} from "@/helpers/transformers";
import {BANDEIRAS_CARTAO, cobrancaParaEdicao, cobrancaParaSalvar, textoBandeirasDaListagem} from "@/helpers/bandeirasCartao";

export default {
  name: "cobrancas",
  components: {
    CrudBase,
  },
  methods: {
    resolveIcon(iconName) {
      const brandIcons = { pix: true };
      if (brandIcons[iconName]) return ["fab", iconName];
      return iconName;
    },
    transformCobranca(cobranca) {
      return cobrancaParaEdicao(cobranca);
    },
    transformSalvar(cobranca) {
      return cobrancaParaSalvar(cobranca);
    },
  },
  data() {
    return {
      url: "/admin/condicoes/cobrancas",
      columns: [
        {
          label: "Id",
          field: "id",
          sortable: false
        },
        {
          label: "Icone",
          field: "icone",
          sortable: false,
          useSlot: true,
        },
        {
          label: "Descrição",
          field: "descricao",
          sortable: false
        },
        {
          label: "Visível B2B",
          field: "acessob2b",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.acessob2b)
        },
        {
          label: "Visível CALL",
          field: "acessocallcenter",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.acessocallcenter)
        },
        {
          label: "Visíel FV",
          field: "acessofv",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.acessofv)
        },
        {
          label: "Ativo",
          field: "ativo",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo)
        },
        {
          label: "Ordem",
          field: "prioridade",
          sortable: false,
        },
        {
          label: "Bandeiras",
          field: "bandeiras_efetivas",
          sortable: false,
          representedAs: textoBandeirasDaListagem
        }
      ],
      formInputs: {
        id: schemaTextField('Cód.', true, 2),
        ativo: schemaBooleanSelect('Ativo', true, 2, 1, 1),
        acessob2b: schemaBooleanSelect('Visível B2B?', true, 2, 1, 1),
        acessocallcenter: schemaBooleanSelect('Visível Call?', true, 2, 1, 1),
        acessofv: schemaBooleanSelect('Visível FV?', true, 2, 1, 1),
        prioridade: schemaNumber('Ordem exibição', true, 2),

        descricao: schemaTextField('Descrição', true, 6),

        icone: schemaIconPicker('Icone', false, 4),

        tipo: schemaSelect('Tipo de Cobrança', false, 3, {'AV' : 'À vista', 'AP' : 'A prazo'}, 'AV', []),
        valorminimo: schemaMoney('Valor mínimo parcela', true, 3, 0),
        cartao: schemaBooleanSelect('É cartão?', true, 3, 1, 0),
        taxacartao: schemaPercent('Taxa cartão (%)', false, 3, 0),

        bandeiras_cartao: schemaMultiSelect('Bandeiras do cartão', false, 6, BANDEIRAS_CARTAO, {
          hidden: "dx: {{$root.cartao}} != 1",
          description: 'Vazio usa as bandeiras vindas do ERP. Sem nenhuma, a cobrança aceita qualquer bandeira.',
        }),
        bandeiras_cartao_erp: {
          ...schemaReadOnly('Bandeiras vindas do ERP', 6),
          ui: { ...schemaReadOnly('Bandeiras vindas do ERP', 6).ui, hidden: "dx: {{$root.cartao}} != 1" },
        },

        inclusao: schemaBooleanSelect('Usa para inclusões?', true, 3, 1),
        link: schemaBooleanSelect('Usa link de pagamento?', true, 3, 1, 0),
        pix: schemaBooleanSelect('É pix?', true, 3, 1, 0),
        usa_consumidor_final: schemaBooleanSelect('Usa no modo cliente final?', true, 3, 1, 0),

        taxafixa: schemaMoney('Despesa acessória (R$)', false, 6),
        descricaotaxafixa: schemaTextField('Descrição da despesa', false, 6),

        observacao: schemaTextArea('Descrição ao cliente a ser exibido no checkout', false, 12),
      },
    };
  },
};
</script>

<style scoped>
.icone-column {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: #f2f2f8;
  color: #3a3e81;
  font-size: 14px;
}

.icone-column-empty {
  color: #98a2b3;
}
</style>
